import { FunctionComponent } from 'react'
import {
  rucksack,
  Box,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@black-bear-energy/rucksack'
import { RFPDocumentSummary } from '@black-bear-energy/black-bear-energy-common'
import { CustomerRFPSection } from './CustomerRFPSection'
import {
  CUSTOMER_RFP_COLUMNS,
  CUSTOMER_RFP_TABLE_WIDTH,
} from '../helpers/DocumentExchange/tableConstants'

export const CustomerRFPTable: FunctionComponent<CustomerRFPTableProps> = ({
  rfpDocumentSummaries,
  searchString,
}) => {
  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: rucksack.palette.divider,
        borderRadius: rucksack.shape.borderRadius,
        overflowX: 'auto',
      }}
    >
      <TableContainer>
        <Table
          sx={{
            tableLayout: 'fixed',
            width: CUSTOMER_RFP_TABLE_WIDTH,
            minWidth: '1000px',
          }}
        >
          <TableHead sx={{ '& .MuiTableCell-head': { fontSize: '14px' } }}>
            <TableRow>
              {CUSTOMER_RFP_COLUMNS.map((column) => (
                <TableCell
                  key={column.title}
                  sx={{ width: `${column.width}%` }}
                >
                  {column.title}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              '& > .MuiTableRow-root:last-child > .MuiTableCell-root': {
                borderBottom: 'none',
              },
            }}
          >
            {rfpDocumentSummaries.map((rfpDocumentSummary, index) => (
              <CustomerRFPSection
                key={rfpDocumentSummary.customerRFPId}
                rfpDocumentSummary={rfpDocumentSummary}
                isLast={index === rfpDocumentSummaries.length - 1}
                searchString={searchString}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}

interface CustomerRFPTableProps {
  rfpDocumentSummaries: RFPDocumentSummary[]
  searchString?: string
}
